/* unplugin-vue-components disabled */import { render } from "./UserRoleListView.vue?vue&type=template&id=dfeeafae&scoped=true"
import script from "./UserRoleListView.vue?vue&type=script&lang=js"
export * from "./UserRoleListView.vue?vue&type=script&lang=js"

import "./UserRoleListView.vue?vue&type=style&index=0&id=dfeeafae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfeeafae"]])

export default __exports__